var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1646 -246)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1646 246)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1672 288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.964,154.21a2.022,2.022,0,0,1-2.054-1.495c-.723-2.007-1.447-4.014-2.144-6.029a.655.655,0,0,0-.742-.524q-8.913.023-17.826,0a.659.659,0,0,0-.753.522c-.68,1.98-1.391,3.95-2.1,5.919a2.087,2.087,0,0,1-2.3,1.607c-1.942,0-3.883.006-5.824,0a2.025,2.025,0,0,1-2.047-2.891c1.441-4.082,14.421-40.6,15.069-42.4a4.021,4.021,0,0,1,4.209-2.988q2.677-.007,5.354,0a4.03,4.03,0,0,1,4.155,2.9c.441,1.183,13.911,39.136,15.081,42.46a2.031,2.031,0,0,1-2.072,2.919C46.946,154.217,42.945,154.218,41.964,154.21ZM28.1,119.831l-5.806,16.22H33.931Z",
    transform: "translate(-6.002 -105.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.112,183.033a2.1,2.1,0,0,0-2.344-2.368c-1.06-.007-2.119,0-3.178,0-1.625,0-2.286.551-2.572,2.211-.219-.108-.39-.193-.561-.28a15.356,15.356,0,0,0-14.835-.053,15.516,15.516,0,0,0-8.656,13.608c-.091,1.564-.012,3.137-.035,4.705a13.828,13.828,0,0,0,.7,4.687,15.922,15.922,0,0,0,11.54,10.876,14.925,14.925,0,0,0,9.4-.568c.808-.311,1.585-.7,2.378-1.053a2.344,2.344,0,0,0,2.581,2.148c1.078-.038,2.159-.036,3.237-.007a2.227,2.227,0,0,0,2.374-2.367C338.095,204.057,338.112,193.545,338.112,183.033Zm-10.062,17.748a6.044,6.044,0,1,1-12.088,0v-4a6.044,6.044,0,1,1,12.088,0v4Z",
    transform: "translate(-257.637 -168.623)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType8);
export default __webpack_public_path__ + "static/media/aioa-icon-type-8.6c9d161ecd0bca8f28b3c8a590f0ffb8.svg";
export { ForwardRef as ReactComponent };